import { useState, useEffect } from 'react';

import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const REMOVE_SHOP_BY_TEST_NAME = 'HP_RemoveShopBy_Jan2026';

export const isRemoveShopByTestVariant = (): boolean =>
    getAbTestV2(REMOVE_SHOP_BY_TEST_NAME)?.variant === 'variant';

export const useIsRemoveShopByTestVariant = (): boolean => {
    const [isVariant, setIsVariant] = useState(false);

    useEffect(() => {
        setIsVariant(isRemoveShopByTestVariant());
    }, []);

    return isVariant;
};

export const trackRemoveShopByTest = (): void => {
    trackAbTestV2Variant(REMOVE_SHOP_BY_TEST_NAME);
};
